export type LeverMode = 'gate' | 'handle';

const STORAGE_KEY = 'glyyd:lever-mode';

export function getLeverMode(): LeverMode {
  try {
    const v = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (v === 'handle' || v === 'gate') return v;
  } catch (_e) {
    // ignore
  }
  // Default to 'handle' because Peach GateForceX appears to be
  // handle-equivalent in our datasets. This avoids double-applying
  // the leverage ratio unless explicitly requested via Advanced toggle.
  return 'handle';
}

export function setLeverMode(mode: LeverMode) {
  try {
    if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (_e) {
    // ignore
  }
}

// Feature flags for Summary/Technique split
export type SummaryRuler = 'perstroke-unified' | 'perstroke-swivel';

export function getSummaryNewUIFlag(): boolean {
  try {
    // CRA exposes env at build time via process.env
    const v = (process.env.REACT_APP_SUMMARY_NEW_UI || '').trim();
    return v === '1' || v.toLowerCase() === 'true';
  } catch {
    return false;
  }
}

export function getSummaryRulerDefault(): SummaryRuler {
  try {
    const v = (process.env.REACT_APP_SUMMARY_RULER || '').trim().toLowerCase();
    if (v === 'perstroke-swivel') return 'perstroke-swivel';
    return 'perstroke-unified';
  } catch {
    return 'perstroke-unified';
  }
}
